import { Component } from '@angular/core';

@Component({
  selector: 'app-calendar-config-container',
  templateUrl: './calendar-config-container.component.html',
  styleUrls: ['./calendar-config-container.component.scss'],
})
export class CalendarConfigContainerComponent {}
